import { render, staticRenderFns } from "./UserLog.vue?vue&type=template&id=272ed887&scoped=true"
import script from "./UserLog.vue?vue&type=script&lang=js"
export * from "./UserLog.vue?vue&type=script&lang=js"
import style0 from "./UserLog.vue?vue&type=style&index=0&id=272ed887&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "272ed887",
  null
  
)

export default component.exports